import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link } from 'react-router-dom';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { Manufacturer } from '../../Models/Manufacturer';
import { FileTypeEnums } from '../../Models/FileType';

export default function ManualDisplay() {
  const [manufacturerData, setManufacturerData] = useState<
    Manufacturer[] | null
  >();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getManufacturer = () => {
    setIsLoading(true);
    ManufacturerApi.getManufacturerListWG()
      .then((res) => {
        setManufacturerData(res.data.filter((item) => item.rimssOemvendorNumber?.startsWith('1') && item.active == true));
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      getManufacturer();
    }, 100);
  }, []);

  return (
    <>
      <div className='w-full mt-4'>
        <div className='container mx-auto p-2'>
          <div className='mb-2 border-b-2'>
            <h1 className='text-gray-900 font-bold text-4xl'>Manuals</h1>
          </div>
          <div className='relative'>
            {isLoading && <Loader />}
            {manufacturerData && (
              <div className='flex flex-wrap gap-10 justify-center h-[calc(100vh-142px)] md:h-[calc(100vh-210px)] overflow-y-auto'>
                {manufacturerData
                  .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
                  .map((manufacturer) => (
                    <div
                      key={manufacturer.id}
                      className='w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 flex justify-center'
                    >
                      <Link
                        to={`/manufacturer/${manufacturer.id}/manuals`}
                        className='w-full'
                      >
                        <div className='flex flex-col items-center rounded-lg border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800 max-w-sm mx-auto p-0 min-h-[320px] w-full'>
                          {/* Image Wrapper */}
                          <div className='w-full h-[200px] flex justify-center items-center overflow-hidden'>
                            <img
                              key={manufacturer.id}
                              src={
                                manufacturer.files &&
                                manufacturer.files?.filter(
                                  (x) => x.fileTypeId === FileTypeEnums.Photo
                                ).length > 0
                                  ? manufacturer.files.filter(
                                      (x) =>
                                        x.fileTypeId === FileTypeEnums.Photo
                                    )[0].fileUrl
                                  : blankImage
                              }
                              alt={manufacturer.name + '-image'}
                              className='h-200 w-full object-cover' // Ensures uniform image size
                            />
                          </div>

                          {/* Text Content */}
                          <div className='flex flex-col flex-grow justify-between p-4 w-full text-center'>
                            <h5 className='text-xl font-bold tracking-tight text-gray-900'>
                              {manufacturer.name!}
                            </h5>
                            <h5 className='tracking-tight text-gray-900'>
                              {manufacturer.rimssOemvendorNumber!}
                            </h5>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
